$(function(){
  $('.slide-main-raden').slick({
    centerMode: true,
    slidesToShow: 1,             
    variableWidth: true, 
    infinite: true,
    asNavFor: '.slide-thum-raden',
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>'
  });
  $('.slide-thum-raden').slick({
    slidesToShow: 7,
    arrows: false,
    asNavFor: '.slide-main-raden',
    variableWidth: true, 
    focusOnSelect: true,
  });

  $('.slide-main-haku').slick({
    centerMode: true,
    slidesToShow: 1,             
    variableWidth: true, 
    infinite: true,
    asNavFor: '.slide-thum-haku',
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>'
  });
  $('.slide-thum-haku').slick({
    slidesToShow: 7,
    arrows: false,
    asNavFor: '.slide-main-haku',
    variableWidth: true, 
    focusOnSelect: true,
  });

  $('.tech-slide').slick({
    centerMode: true,
    slidesToShow: 1,             
    variableWidth: true, 
    infinite: true,
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>'
  });  

  const movie = `<div id="movie" class="movie">
        <div class="movie__close"><span></span></div>
        <div class="movie__inner"><video src="https://magazine.knot-designs.com/shopify/img/10th/10th_top-movie-2.mp4" loop muted autoplay playsinline></div>
    </div>`;
  console.log(movie);
  if (sessionStorage.getItem('access')) {
    //2回目以降アクセス時の処理
    console.log('2回目以降のアクセスです');
    $(document).on('click', '.movie__close, .movie', function(){
        $('#movie').hide();
        $('#movie-banner').remove();
    });
  } else {
    //初回アクセス時の処理
    sessionStorage.setItem('access', 0);
    console.log('初回アクセスです');
    $('.anniversary').prepend(movie);
    $(document).on('click', '.movie__close, .movie', function(){
        $('#movie').hide();
    });
  }
  $(document).on('click', '#movie-banner', function(){
    $('.anniversary').prepend(movie);
  });
  const radenTop = $('#raden').offset().top;
  console.log(radenTop);
  const wh = $(window).height();
  console.log(wh);
  $(window).on('scroll', function(){
      const scroll = $(this).scrollTop();
      console.log(scroll);
      if(radenTop < (scroll + wh)) {
          $('#movie-banner').fadeOut(200);
      }else {
          $('#movie-banner').fadeIn(200);
      }
  });
  
});